import Swal from "sweetalert2";
import { IntlShape } from "react-intl";
import { Meeting } from "../interfaces";

interface handleCoordinateProps {
    setLatitudeMap: (latitude: number) => void;
    setLongitudeMap: (longitude: number) => void;
    intl: any
    formik: any
}

const handleReversLatLongToAddress = (lat: number, long: number, formik: any) => {
    fetch(`https://tool.looyal.id/general/gmaps/convert-latlong?lat=${lat}&long=${long}`)
        .then(response => response.json())
        .then(data => {
            formik.setFieldValue("location", data.data, false);
        })
        .catch((error) => {
            console.log(error)
        });
}

const alertErrorCoordinate = (message: string, intl: any, setLatitudeMap: (latitude: number) => void, setLongitudeMap: (longitude: number) => void, formik: any) => {
    Swal.fire({
        icon: 'error',
        title: intl.formatMessage({ id: "ALERT.TITLE.ERROR" }),
        html: message,
        confirmButtonText: 'Ok',
        target: document.getElementById('add-meeting-modal'),
        heightAuto: false,
    });
    setLatitudeMap(0);
    setLongitudeMap(0);
    formik.setFieldValue("location", "");
}

export const handleCoordinate = async ({ setLatitudeMap, setLongitudeMap, intl, formik }: handleCoordinateProps) => {
    try {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitudeMap(position.coords.latitude);
                    setLongitudeMap(position.coords.longitude);
                    handleReversLatLongToAddress(position.coords.latitude, position.coords.longitude, formik);
                },
                (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        var message1 = intl.formatMessage({ id: "BROWSER.GEOLOCATION.TUTORIAL" })
                        alertErrorCoordinate(message1, intl, setLatitudeMap, setLongitudeMap, formik)
                    }
                }
            );
        } else {
            var message2 = intl.formatMessage({ id: "BROWSER.SUPPORT.GEOLOCATION" })
            alertErrorCoordinate(message2, intl, setLatitudeMap, setLongitudeMap, formik);
        }
    } catch (error) {
        var message3 = intl.formatMessage({ id: "BROWSER.GEOLOCATION.PERMISSION_DENIED" })
        alertErrorCoordinate(message3, intl, setLatitudeMap, setLongitudeMap, formik)
    }
};

export const getStatusMeeting = (eachData: Meeting, intl: IntlShape) => {
    if (eachData.meeting_status === "PLANNED" && eachData.type !== 'SCHEDULED_VISIT') {
        return intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' })
    } else if (eachData.meeting_status === "COMPLETED") {
        return intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })
    } else if (eachData.meeting_status === "ONGOING") {
        return intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' })
    } else if ((eachData.approval?.status === "PENDING" && eachData.type === 'SCHEDULED_VISIT' && eachData.meeting_status !== "CANCELLED") ||
        (eachData.meeting_status === "PLANNED" && eachData.type === 'SCHEDULED_VISIT' && eachData.approval?.status === "PENDING")) {
        return intl.formatMessage({ id: 'MEETING.STATUS.PENDING' })
    } else if (eachData.approval?.status === "APPROVED" && eachData.type === 'SCHEDULED_VISIT' && eachData.meeting_status !== "CANCELLED") {
        return intl.formatMessage({ id: 'MEETING.STATUS.APPROVED' })
    } else if (eachData.approval?.status === "REJECTED" && eachData.type === 'SCHEDULED_VISIT' && eachData.meeting_status !== "CANCELLED") {
        return intl.formatMessage({ id: 'MEETING.STATUS.REJECTED' })
    } else {
        return intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })
    }
}

export const getStatusValueMeeting = (value: string, intl: IntlShape) => {
    if (value === intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' })) {
        return "PLANNED"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })) {
        return "COMPLETED"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' })) {
        return "ONGOING"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' })) {
        return "PENDING"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.APPROVED' })) {
        return "APPROVED"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.REJECTED' })) {
        return "REJECTED"
    } else if (value === intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })) {
        return "CANCELLED"
    } else {
        return "CANCELLED"
    }
}